"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalSection = void 0;
var _mui = require("@ori-ui/mui");
var _shared = require("../shared");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(({
  theme
}) => (0, _shared.basicGridStyles)(theme));
const Title = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.text.secondary,
  fontWeight: 'bold',
  gridColumnEnd: -1,
  gridColumnStart: 1,
  padding: theme.spacing(4, 0, 1)
}));
const ModalSection = ({
  title,
  children
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Title, {
    variant: "subtitle1",
    children: title
  }), children]
});
exports.ModalSection = ModalSection;